export const APP_HOST = process.env.REACT_APP_HOST ?? "";
export const APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT ?? "";
export const APP_PROJECT_ID = process.env.REACT_APP_PROJECT_ID ?? "";
export const APP_COLLECTION_ID = process.env.REACT_APP_COLLECTION_ID ?? "";
